import React from 'react';

import { Link } from "react-router-dom";
import strings from '../strings';

import Wrapper from './Layout/Wrapper';

const Readmore = ({ visibleText, currentSlug, language }) => {
    if (!visibleText) {
        return null;
    }

    return (
        <Wrapper>
            <div className="readmore">
                <p className="text readmore__initial-text">{visibleText}</p>
                <Link to={`/guide/${currentSlug}/readmore`} className="readmore__link">
                    {strings.READMORE_BUTTON_LABEL[language]}
                </Link>
            </div>
        </Wrapper>
    );
}

export default Readmore;